import { AddressEntry } from "@app/components/AddressEntry/AddressEntry"
import { Loader } from "@app/components/core/Loader/Loader"
import Button from "@app/components/move2Library/Button/Button"
import MyParadiseAddressModal from "@app/modals/MyParadise/MyParadiseAddressModal/MyParadiseAddressModal"
import { useGetStrings } from "@app/store/service/cmsService"
import { useGetRelationAddresses, useGetTransporterCountries } from "@app/store/service/connectorService"
import { appStore } from "@app/store/store"
import { ADRESS_TYPES } from "@app/utils/constants"
import { getTransporterIdsForCountrySelection } from "@app/utils/getTransporterIds"
import { Modal, useModal } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { useState } from "react"

export const AddressSelectionModal = ({ address }) => {
	const { data: addresses, isFetching } = useGetRelationAddresses()
	const { showModal, hideModal } = useModal()
	const [usedAddress, setAddress] = useState(address)
	const formattedOrder = useSelector(state => state.order.formattedOrder)
	const { data: transporterCountries } = useGetTransporterCountries({ transporterIds: getTransporterIdsForCountrySelection(formattedOrder) })
	const {
		data: { buttonClose },
	} = useGetStrings()

	return (
		<Modal ariaLabelledBy="address-selection-modal-title">
			<Modal.Closer ariaLabel={buttonClose} />
			<Modal.Header>
				<h2 id="address-selection-modal-title" className="h-without-default-style">
					{" "}
					Adresse auswählen
				</h2>
			</Modal.Header>
			<Modal.Body>
				{addresses &&
					addresses
						.filter(e => e.addressTypeId === address.addressTypeId)
						.filter(e => (address.addressTypeId === 2 ? transporterCountries?.some(country => country.countryId === e.countryId) : true)) //Step 2: Only filter by transporterCountries if addressTypeId is 2
						.map(adr => (
							<AddressEntry
								key={adr.addressId}
								address={adr}
								className={"clickable " + (adr.addressToken === usedAddress?.addressToken ? "color-bg-secondary color-fg-white" : "")}
								selected={adr.addressToken === usedAddress?.addressToken}
								onClick={() => {
									adr.addressToken === usedAddress.addressToken ? setAddress({ addressTypeId: address.addressTypeId }) : setAddress(adr)
								}}
							/>
						))}

				<div className="mb-3">
					<Loader show={isFetching} />
				</div>

				<Button
					fillWidth
					style="outlined"
					className="primary"
					onClick={() => {
						showModal(MyParadiseAddressModal, {
							addressTypeId: usedAddress.addressTypeId,
							useTransporterCountries: true,
							afterSave: addresses => {
								const filtered = addresses.filter(e => e.addressTypeId === usedAddress.addressTypeId)
								const newAddress = filtered[filtered.length - 1]
								if (newAddress.addressTypeId === ADRESS_TYPES.INVOICE) {
									appStore.set("core.invoiceAddress", { ...newAddress })
								} else {
									appStore.set("core.deliveryAddress", { ...newAddress })
								}
							},
						})
					}}
				>
					<div className="medium">+ Adresse hinzufügen</div>
				</Button>
			</Modal.Body>
			<Modal.Footer className="flex flex-center">
				<Button
					style="filled"
					className="primary"
					onClick={() => {
						if (usedAddress.addressTypeId === ADRESS_TYPES.INVOICE) {
							appStore.set("core.invoiceAddress", usedAddress.addressToken ? usedAddress : undefined)
						} else {
							appStore.set("core.deliveryAddress", usedAddress.addressToken ? usedAddress : undefined)
						}
						hideModal()
					}}
				>
					Auswählen
				</Button>
			</Modal.Footer>
		</Modal>
	)
}
